export const GetUserRole =()=> {
    const auth= localStorage.getItem('usertype')
    return auth;
    }

export const SetUserRole =(data)=> {
        const auth= localStorage.setItem('usertype',data)
        return auth;
        }

export const RemoveUserRole =()=> {
            localStorage.removeItem('usertype')
                }